<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dbWork"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="expWorkList"></LeftSideBar>
    </div>

    <div id="deptContentBox" class="base-content">
      <!-- 搜索 -->
      <div id="searchBox">
        <el-form
          ref="searchFileForm"
          :model="searchFileForm"
          label-width="110px"
        >
          <el-form-item label="使用人员：">
            <el-input
              v-model="searchFileForm.toUser"
              placeholder="请输入关键字"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用部门：">
            <el-input
              v-model="searchFileForm.toDept"
              placeholder="请输入关键字"
            ></el-input>
          </el-form-item>
          <el-form-item label="导出用户：">
            <el-input
              v-model="searchFileForm.expUser"
              placeholder="请输入关键字"
            ></el-input>
          </el-form-item>
          <el-form-item label="资源状态：">
            <el-select v-model="searchFileForm.status" clearable>
              <el-option value="10" label="导出中"> </el-option>
              <el-option value="20" label="导出成功"> </el-option>
              <el-option value="30" label="导出失败"> </el-option>
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="
              currentPage = 1;
              onSearch();
            "
            >查询</el-button
          >
        </el-form>
      </div>
      <!-- 搜索end -->
      <el-table
        :data="exportTableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          prop="id"
          show-overflow-tooltip
          label="ID"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="expUser"
          show-overflow-tooltip
          label="导出用户"
          width="100"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="toUser"
          show-overflow-tooltip
          label="使用人员"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="toDept"
          show-overflow-tooltip
          label="使用部门"
          width="100"
          align="center"
        >
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="导出内容"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.expFormat == 'Word'">导出词条内容</span>
            <span v-if="scope.row.expFormat == 'Resource'">导出资源内容</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == '10'">导出中</span>
            <span v-if="scope.row.status == '20'">导出成功</span>
            <span v-if="scope.row.status == '30'">导出失败</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="expYt"
          show-overflow-tooltip
          label="用途"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="expAudit"
          show-overflow-tooltip
          label="审核意见"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="url"
          show-overflow-tooltip
          label="URL"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          width="100"
          show-overflow-tooltip
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <span
              class="right-add-button"
              @click="downloadExport(scope.row.url)"
              >【下载】</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    return {
      exportTableData: [],
      searchFileForm: {},
      // 分页
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
    };
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
  },
  methods: {
    // 搜索
    onSearch() {
      this.searchParam();
    },
    // 加载数据
    searchParam() {
      let that = this;
      let params = Object.assign({}, this.searchFileForm);
      params.size = this.pageSize;
      params.page = this.currentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/export/expWork/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            var currentData = response.obj;
            if (currentData.totalSize == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize = currentData.total;
            that.exportTableData = currentData.list;
            that.currentPage = currentData.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 下载导出文件
    downloadExport(url) {
      console.log(url);
      var that = this;
      if (url) {
        var downloadA = document.createElement("a");
        downloadA.href = url;
        downloadA.download;
        downloadA.click();
      } else {
        that.$message({
          message: "当前状态下没有导出文件下载",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      }
    },
  },
};
</script>

<style>
</style>